/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function HandshakeIcon(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                fill='none'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>Handshake Icon</title>
                <g
                    id='Symbols'
                    stroke={iconColor || 'none'}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.8'
                >
                    <g id='Group'>
                        <path
                            d='M9.16669 14.1668L10.8334 15.8335C10.9975 15.9976 11.1924 16.1279 11.4069 16.2167C11.6213 16.3055 11.8512 16.3513 12.0834 16.3513C12.3155 16.3513 12.5454 16.3055 12.7598 16.2167C12.9743 16.1279 13.1692 15.9976 13.3334 15.8335C13.4975 15.6693 13.6277 15.4745 13.7166 15.26C13.8054 15.0455 13.8511 14.8156 13.8511 14.5835C13.8511 14.3513 13.8054 14.1215 13.7166 13.907C13.6277 13.6925 13.4975 13.4976 13.3334 13.3335'
                        />
                        <path
                            d='M11.6667 11.6666L13.75 13.7499C14.0815 14.0815 14.5312 14.2677 15 14.2677C15.4688 14.2677 15.9185 14.0815 16.25 13.7499C16.5815 13.4184 16.7678 12.9688 16.7678 12.4999C16.7678 12.0311 16.5815 11.5815 16.25 11.2499L13.0167 8.0166C12.5479 7.54843 11.9125 7.28546 11.25 7.28546C10.5875 7.28546 9.95209 7.54843 9.48334 8.0166L8.75001 8.74993C8.41848 9.08145 7.96885 9.2677 7.50001 9.2677C7.03116 9.2677 6.58153 9.08145 6.25001 8.74993C5.91849 8.41841 5.73224 7.96877 5.73224 7.49993C5.73224 7.03109 5.91849 6.58145 6.25001 6.24993L8.59167 3.90826C9.35187 3.15005 10.3433 2.66706 11.4089 2.53574C12.4745 2.40443 13.5535 2.63229 14.475 3.18326L14.8667 3.4166C15.2215 3.63075 15.6434 3.70503 16.05 3.62493L17.5 3.33326'
                        />
                        <path
                            d='M17.5 2.5L18.3334 11.6667H16.6667'
                        />
                        <path
                            d='M2.50002 2.5L1.66669 11.6667L7.08335 17.0833C7.41487 17.4149 7.86451 17.6011 8.33335 17.6011C8.8022 17.6011 9.25183 17.4149 9.58335 17.0833C9.91488 16.7518 10.1011 16.3022 10.1011 15.8333C10.1011 15.3645 9.91488 14.9149 9.58335 14.5833'
                        />
                        <path
                            d='M2.5 3.3335H9.16667'
                        />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}